import * as React from 'react'
import { Text, TouchableOpacity, View } from 'react-native'
import styled from '@theme/styled-components'

import Modal from '@components/modal/Modal'
import Icon from '@components/icon/Icons'
import Button from '@components/button/Button'

import useI18n from '@i18n/useI18n'

import theme from '@theme/Theme'

interface Props {
  description?: string
  title?: string
  onFinished: () => void
}

const MessageAlertContent = ({ description, title, onFinished }: Props) => {
  const i18n = useI18n()

  return (
    <ModalContent>
      <CrossContainer activeOpacity={0.9} onPress={onFinished}>
        <Icon name="close" size={24} color={theme.colors.primary} />
      </CrossContainer>
      {!!title && <ModalTitle>{title}</ModalTitle>}
      {!!description && <ModalDescription>{description}</ModalDescription>}

      <ButtonContainer>
        <Button status="active" label={i18n.t('common.finish')} onClick={onFinished} />
      </ButtonContainer>
    </ModalContent>
  )
}

const MessageAlert = {
  open: (props: Props) => {
    Modal.open({
      Content: () => <MessageAlertContent {...props} />,
    })
  },
  close: () => {
    Modal.close()
  },
}

export default MessageAlert

const ModalContent = styled(View)`
  width: ${(props) => (props.theme.breakpoint === 'phone' ? 300 : 600)}px;
  border-radius: 4px;
  padding: ${(props) => (props.theme.breakpoint === 'phone' ? `24px 0 16px 0px` : `24px`)};
  background-color: ${(props) => props.theme.colors.background};
`
const ModalTitle = styled(Text)`
  ${(props) => props.theme.fonts.Title3};
  padding: 24px 16px;
  text-align: center;
`
const ModalDescription = styled(Text)`
  ${(props) => props.theme.fonts.Body};
  color: ${(props) => props.theme.colors.tertiary};
  padding: 0 16px 24px;
  text-align: center;
`
const ButtonContainer = styled(View)`
  ${(props) =>
    props.theme.breakpoint !== 'phone' ? `width: 280px; align-self: center; margin-top: 48px;` : `padding: 0px 16px;`}
`
const CrossContainer = styled(TouchableOpacity)`
  position: absolute;
  top: 0;
  right: 0;
  padding: ${(props) => (props.theme.breakpoint !== 'phone' ? 16 : 8)}px;
`
